/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body Fat Percentage Calculator (US Navy) — Toolverse`)
};

const es_bf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Porcentaje de Grasa Corporal (Método Marina de EE. UU.) — Toolverse`)
};

const de_bf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körperfettanteil-Rechner (US Navy) — Toolverse`)
};

const nl_bf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lichaamsvetpercentage Calculator (US Navy) — Toolverse`)
};

const fr_bf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de Masse Grasse (Méthode US Navy) — Toolverse`)
};

const it_bf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di percentuale di grasso corporeo (US Navy) — Toolverse`)
};

const pt_br2_bf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Percentual de Gordura Corporal (Marinha dos EUA) — Toolverse`)
};

const pt_bf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Percentagem de Gordura Corporal (Marinha dos EUA) — Toolverse`)
};

const ja_bf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体脂肪率計算機(米海軍式) — Toolverse`)
};

const zh_bf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体脂率计算器（美国海军法）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_meta_title", locale)
	if (locale === "en") return en_bf_meta_title(inputs)
	if (locale === "es") return es_bf_meta_title(inputs)
	if (locale === "de") return de_bf_meta_title(inputs)
	if (locale === "nl") return nl_bf_meta_title(inputs)
	if (locale === "fr") return fr_bf_meta_title(inputs)
	if (locale === "it") return it_bf_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_bf_meta_title(inputs)
	if (locale === "pt") return pt_bf_meta_title(inputs)
	if (locale === "ja") return ja_bf_meta_title(inputs)
	return zh_bf_meta_title(inputs)
};